export const iplpRecipeFields = `
    id
    slug
    name
    formName
    indication
`;
